module.exports = __webpack_public_path__ + "img/prayer-journal_B095GRW2D3.ae82a943.jpg";